module.exports = __webpack_public_path__ + "media/images/covers/foundation/University-of-Surrey-logo-622ef759d028f45c210f70c642ff148c.svg";